/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Remove_BlockInputs */

const cs_builder_remove_block = /** @type {(inputs: Builder_Remove_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odstranit blok`)
};

const en_builder_remove_block = /** @type {(inputs: Builder_Remove_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove block`)
};

/**
* | output |
* | --- |
* | "Remove block" |
*
* @param {Builder_Remove_BlockInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_remove_block = /** @type {((inputs?: Builder_Remove_BlockInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Remove_BlockInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_remove_block(inputs)
	return cs_builder_remove_block(inputs)
});